export default __webpack_public_path__ + "static/logo-9828aa7f8a90a4469503bd0a4560f36b.png";